<template>
    <div class="search-select-box">
        <div class="search-select-list">
            <span class="search-sl-note">命局</span>
            <div id='situation' class="search-sl-list">
                <span class="search-sl-item" v-bind:class="{'item-cur': searchSelectedData.situation == 0}" @click="clickItem('situation', 0)">不限</span>
                <span class="search-sl-item" v-bind:class="{'item-cur': searchSelectedData.situation == situation.value}" @click="clickItem('situation', situation.value)" v-for="situation in situationList" v-bind:key="'situation' + situation.value">{{situation.text}}</span>
            </div>
        </div>
        <div class="search-select-list">
            <span class="search-sl-note">性别</span>
            <div id='sex' class="search-sl-list">
                <span class="search-sl-item" v-bind:class="{'item-cur': searchSelectedData.sex == -1}" @click="clickItem('sex', -1)">不限</span>
                <span class="search-sl-item" v-bind:class="{'item-cur': searchSelectedData.sex == 0}" @click="clickItem('sex', 0)">男</span>
                <span class="search-sl-item" v-bind:class="{'item-cur': searchSelectedData.sex == 1}" @click="clickItem('sex', 1)">女</span>
            </div>
        </div>
        <div class="search-select-list">
            <span class="search-sl-note">年龄</span>
            <div id='age' class="search-sl-list">
                <span class="search-sl-item" v-bind:class="{'item-cur': searchSelectedData.age == 0}" @click="clickItem('age', 0)">升序</span>
                <span class="search-sl-item" v-bind:class="{'item-cur': searchSelectedData.age == 1}" @click="clickItem('age', 1)">降序</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchSelectBox',
    computed: {
        searchSelectedData() {
            return this.$store.state.search.searchSelectedData;
        }
    },
    data() {
        return {
            situationList: [
                {text: '印重', value: 1},
                {text: '命旺', value: 2},
                {text: '伤官', value: 3},
                {text: '财旺', value: 4},
                {text: '煞重', value: 5},
            ]
        }
    },
    methods: {
        clickItem(type, value){
            var parentNode = document.getElementById(type);
            var index = type == 'sex' ? (value + 1) : value;
            for(var i = 0; i < parentNode.childElementCount; i++){
                var childNode = parentNode.children[i];
                childNode.className = 'search-sl-item';
            }
            parentNode.children[index].className = 'search-sl-item item-cur';
            this.$store.state.search.searchSelectedData[type] = value;
            console.log('clickItem----', type, value);
        }
    }
}
</script>